export default {
  priority: 98,
  name: app.translate("بخشودگی"),
  path: "device",
  permissions: ["TimeAttendanceMenu/DeviceMenu/DeviceListMenu","Forgiveness"],
  icon: "calendar-clock",
  drawer: true,
};


